import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Buyer } from '../models/buyer.model';
import { Site } from '../diary/models/site.model';
import { AuthService } from '../core/auth-service';
import { UserTask } from '../task-list/models/user-task.model';
import { TaskSortTypes } from '../task-list/enums/task-sort-types';

@Injectable({
  providedIn: 'root',
})

export class BuyerService {
  constructor(private http: HttpClient, private authService: AuthService) { }

  async getCurrentBuyer(): Promise<Buyer> {
    const buyer = sessionStorage.getItem('current_buyer');
    if (buyer) {
      return JSON.parse(buyer);
    } else {
      const username = this.authService.getUser()?.username.split('@')[0].toLowerCase();
      await this.getBuyerByUsername$(username).toPromise();
      const buyer = sessionStorage.getItem('current_buyer');
      if (buyer) {
        return JSON.parse(buyer);
      } else {
        return undefined;
      }
    }
  }

  getCurrentSiteFromStorage(): Site {
    const site = sessionStorage.getItem('current_site');
    // This covers all cases:  key missing -> null, stored "undefined" -> string,  stored "null" -> string
    if (!site || site === 'undefined' || site === 'null') {
      return undefined;
    } else {
      return JSON.parse(site);
    }
  }

  setCurrentSiteInStorage(site: Site) {
    if (site !== null) {
      sessionStorage.setItem('current_site', JSON.stringify(site));
    } else {
      sessionStorage.removeItem('current_site');
    }
  }

  getBuyer$(employeeId: number): Observable<Buyer> {
    return this.http.get<Buyer>(`${environment.ppxPrivateApi}api/Buyer/${employeeId}`)
      .pipe(
        tap(result => {
          sessionStorage.setItem('current_buyer', JSON.stringify(result));
        }),
        catchError(err => throwError(err))
      );
  }

  getBuyerByUsername$(username: string): Observable<Buyer> {
    return this.http.get<Buyer>(`${environment.ppxPrivateApi}api/Buyer?username=${username}`)
      .pipe(
        tap(result => {
          sessionStorage.setItem('current_buyer', JSON.stringify(result));
        }),
        catchError(err => throwError(err))
      );
  }

  sortTasks(sortOrder, tasks: Array<UserTask>): Array<UserTask> {
    if (sortOrder === TaskSortTypes.AppointmentDate) {
      tasks.sort((a, b) => this.compareByAppointmentDate(a, b));
    } else if (sortOrder === TaskSortTypes.TaskType) {
      tasks.sort((a, b) => this.compareByTaskType(a, b));
    }
    return tasks;
  }

  compareByTaskType(a: UserTask, b: UserTask): number {
    if (b.sortOrder < a.sortOrder) { return 1; }
    if (b.sortOrder > a.sortOrder) { return -1; } else {
      if (b.appointmentDate < a.appointmentDate) { return 1; }
      if (b.appointmentDate > a.appointmentDate) { return -1; }
      return 0;
    }
  }

  compareByAppointmentDate(a: UserTask, b: UserTask): number {
    if (a.appointmentDate > b.appointmentDate) {
      return 1;
    } else if (b.appointmentDate > a.appointmentDate) {
      return -1;
    } else {
      return 0;
    }
  }
}
